import './ChartOverlaysBorder.css';
export var chartOverlaysBorder = '_ukjzmj0-2-0-1';
export var chartOverlaysBorder__rightAxis = '_ukjzmj2-2-0-1';
export var chartOverlaysBorder__topAxis = '_ukjzmj4-2-0-1';
export var chartOverlaysBorder__xAxis = '_ukjzmj1-2-0-1';
export var chartOverlaysBorder__yAxis = '_ukjzmj3-2-0-1';